import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';
import { Routes, RouterModule } from '@angular/router';

import { ReportsComponent } from '../reports/reports.component';
import { CompareComponent } from '../compare/compare.component';

const COMPAREROUTES: Routes = [
    {
        path: 'repcomp', component: ReportsComponent,
        children: [
            { path: 'compare', component: CompareComponent }
        ]
    }
];

export const COMPAREROUTING: ModuleWithProviders = RouterModule.forChild(COMPAREROUTES);



// WEBPACK FOOTER //
// ./src/app/compare/compare.routing.ts